export default "__VITE_ASSET__DJY3ffU7__"